import { PrincipalIdSchema } from "@core/domains/identity";
import { identity } from "@core/foundation/function";
import { ulid } from "@core/foundation/id";
import {
  createModel,
  createModelId,
  createModelSchemas,
  noModelUpdate,
} from "@core/foundation/model";
import { z } from "@core/zod";

import { ProjectIdSchema } from "./project.ts";
import { AgentSessionEventPayloadSchema } from "./shared/agent-session-event-payload.ts";
import { ID_PREFIX } from "./shared/id-prefix.ts";

const {
  generateId: generateAgentSessionEventId,
  idSchema: AgentSessionEventIdSchema,
} = createModelId({ digestFn: ulid, idPrefix: ID_PREFIX.AGENT_SESSION_EVENT });

export const AgentSessionEvent = createModel({
  create: (item, schema) => {
    return { ...schema.decode(item), id: generateAgentSessionEventId() };
  },
  schemas: createModelSchemas({
    base: z.object(
      {
        agent: z.enum(["claude-code", "codex"]),
        id: AgentSessionEventIdSchema,
        payload: AgentSessionEventPayloadSchema,
        principalId: PrincipalIdSchema,
        projectId: ProjectIdSchema,
        sessionId: z.safeId(),
      },
      {
        agent: "The agent host that emitted the event, claude-code or codex.",
        id: "The unique identifier for the event.",
        payload: "What happened in the session, discriminated on its kind.",
        principalId: "The id of the principal the event belongs to.",
        projectId: "The id of the project the event belongs to.",
        sessionId: "The id of the agent session the event belongs to.",
      },
    ),
    derive: {
      create: schema => schema.omit({ id: true }),
      recovery: identity,
      update: noModelUpdate,
    },
  }),
  update: (item, update, schema) => {
    return { ...item, ...schema.decode(update) };
  },
});

export interface AgentSessionEvent
  extends z.infer<typeof AgentSessionEvent.schema> {}
